(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["an-disciplines"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('[data-an-disciplines]').forEach(function (root) {
      var items = root.querySelectorAll('.an-disc__item');
      var imgs = root.querySelectorAll('.an-disc__img');
      function activate(i) {
        items.forEach(function (it, n) { it.classList.toggle('is-active', n === i); });
        imgs.forEach(function (im) { im.classList.toggle('is-active', parseInt(im.dataset.index, 10) === i); });
      }
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activate(i); });
        it.addEventListener('click', function () { activate(i); });
      });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-header"]) return;
  try {
    
    (function () {
      var h = document.querySelector('[data-an-header]');
      if (!h) return;
      var isHome = h.getAttribute('data-home') === 'true';
      // Horizon scrolla dentro .page-wrapper, non su window
      var sc = document.querySelector('.page-wrapper');
      // max tra .page-wrapper (scroll desktop Horizon) e finestra (scroll mobile) → funziona su entrambi
      function stop() { return Math.max(sc ? sc.scrollTop : 0, window.scrollY || document.documentElement.scrollTop || 0); }
      function onScroll() { h.classList.toggle('is-transparent', isHome && stop() <= 40); }
      onScroll();
      if (isHome) {
        (sc || window).addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('scroll', onScroll, { passive: true });
      }
      var burger = h.querySelector('[data-an-burger]');
      var mobile = h.querySelector('[data-an-mobile]');
      if (burger && mobile) {
        burger.addEventListener('click', function () {
          if (mobile.hasAttribute('data-open')) { mobile.removeAttribute('data-open'); mobile.setAttribute('hidden', ''); }
          else { mobile.setAttribute('data-open', ''); mobile.removeAttribute('hidden'); }
        });
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-reviews"] && !Shopify.designMode) return;
  try {
    
    (function () {
      function initReviewsScroller(scope) {
        (scope || document).querySelectorAll('[data-an-reviews-scroller]').forEach(function (viewport) {
          if (viewport.dataset.anInit === '1') return;
          viewport.dataset.anInit = '1';

          var track = viewport.querySelector('.an-reviews__track');
          if (!track) return;

          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          var SPEED = 30;          // px/sec di auto-scroll
          var RESUME_DELAY = 3000; // ms di inattività prima di riprendere
          var loopWidth = 0;
          var hovering = false;
          var dragging = false;
          var pauseUntil = 0;
          var lastTs = 0;
          var normalizing = false;

          function measure() {
            loopWidth = track.scrollWidth / 3;
            if (loopWidth > 0 && viewport.scrollLeft < 1) {
              normalizing = true;
              viewport.scrollLeft = loopWidth;
              normalizing = false;
            }
          }

          // Mantiene la posizione nella copia centrale: il salto di ±loopWidth è invisibile
          function normalize() {
            if (loopWidth <= 0) return;
            var x = viewport.scrollLeft;
            if (x < loopWidth * 0.5) {
              normalizing = true; viewport.scrollLeft = x + loopWidth; normalizing = false;
            } else if (x > loopWidth * 1.5) {
              normalizing = true; viewport.scrollLeft = x - loopWidth; normalizing = false;
            }
          }

          function pause() { pauseUntil = Date.now() + RESUME_DELAY; }

          viewport.addEventListener('scroll', function () {
            if (normalizing) return;
            normalize();
          }, { passive: true });

          viewport.addEventListener('mouseenter', function () { hovering = true; });
          viewport.addEventListener('mouseleave', function () { hovering = false; pause(); });
          viewport.addEventListener('wheel', pause, { passive: true });
          viewport.addEventListener('touchstart', pause, { passive: true });
          viewport.addEventListener('touchmove', pause, { passive: true });
          viewport.addEventListener('touchend', pause, { passive: true });
          viewport.addEventListener('keydown', pause);

          // Drag col mouse su desktop (il touch usa lo scroll nativo)
          var dragStartX = 0, dragStartScroll = 0;
          viewport.addEventListener('pointerdown', function (e) {
            if (e.pointerType !== 'mouse' || e.button !== 0) return;
            dragging = true;
            dragStartX = e.clientX;
            dragStartScroll = viewport.scrollLeft;
            viewport.classList.add('is-dragging');
            viewport.setPointerCapture(e.pointerId);
            pause();
          });
          viewport.addEventListener('pointermove', function (e) {
            if (!dragging) return;
            viewport.scrollLeft = dragStartScroll - (e.clientX - dragStartX);
            pause();
          });
          function endDrag() {
            if (!dragging) return;
            dragging = false;
            viewport.classList.remove('is-dragging');
            pause();
          }
          viewport.addEventListener('pointerup', endDrag);
          viewport.addEventListener('pointercancel', endDrag);

          window.addEventListener('resize', measure);
          measure();
          // le immagini lazy cambiano la larghezza del track dopo il load
          if (document.readyState === 'complete') { measure(); }
          else { window.addEventListener('load', measure); }

          function tick(ts) {
            if (!lastTs) lastTs = ts;
            var dt = Math.min((ts - lastTs) / 1000, 0.1);
            lastTs = ts;
            if (loopWidth <= 0) measure();
            var paused = reduceMotion || hovering || dragging || Date.now() < pauseUntil;
            if (!paused && loopWidth > 0) {
              normalizing = true;
              viewport.scrollLeft += SPEED * dt;
              normalizing = false;
              normalize();
            }
            requestAnimationFrame(tick);
          }
          requestAnimationFrame(tick);
        });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { initReviewsScroller(document); });
      } else {
        initReviewsScroller(document);
      }
      document.addEventListener('shopify:section:load', function (e) { initReviewsScroller(e.target); });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["an-video"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.an-video__card').forEach(function (card) {
      function play() {
        if (card.dataset.loaded) return;
        var id = card.getAttribute('data-youtube');
        if (!id) return;
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
        f.allow = 'autoplay; encrypted-media; picture-in-picture';
        f.setAttribute('allowfullscreen', '');
        card.querySelector('.an-video__frame').appendChild(f);
        card.dataset.loaded = '1';
        card.classList.add('is-playing');
      }
      card.addEventListener('click', play);
      card.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); play(); } });
    });
    document.querySelectorAll('.an-video__carousel').forEach(function (car) {
      var track = car.querySelector('[data-an-vtrack]');
      var prev = car.querySelector('[data-an-vprev]');
      var next = car.querySelector('[data-an-vnext]');
      function step() { var c = track.querySelector('.an-video__card'); return c ? c.offsetWidth + 20 : 300; }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
